import React from 'react';
import './Footer.css'; // Import your CSS file for styling
import { BsWindowSidebar } from 'react-icons/bs';

const Footer = () => {
    const handleTerms=()=>{
        const BaseUrl=window.location.origin;
        window.open(BaseUrl+"/terms/",'_blank').focus();
    }
    const handlePrivacy=()=>{
        const BaseUrl=window.location.origin;
        window.open(BaseUrl+"/privacy/",'_blank').focus();
    }
    const handleBlogs=()=>{
        const BaseUrl=window.location.origin;
        window.open(BaseUrl+"/blogs/",'_blank').focus();
    }
    const handleHelp=()=>{
        const BaseUrl=window.location.origin;
        window.open(BaseUrl+"/help/",'_blank').focus();
    }
    return (
        <footer className="footer">
            <div className="footer-left">
                <p>©2026 All Rights Reserved</p>
            </div>
            <div className="footer-right">
                <p>
                 <a href="javascript:;" onClick={handleTerms}>Terms & Conditions</a>| <a href="javascript:;" onClick={handlePrivacy}>Privacy Policy</a>| <a href="javascript:;" onClick={handleBlogs}>Blogs</a>| <a href="javascript:;" onClick={handleHelp}>Help</a>
                </p>
            </div>
        </footer>
    );
};

export default Footer;
